/**
 * Show more security logs
 */
function spbcSecLogsShowMoreListen() {
    jQuery('#spbc_show_more_button').on('click', function() {
        if (spbcSettingsSecLogs.clicks < 2) {
            spbcSettingsSecLogs.clicks++;
            let data = {
                action: 'spbc_show_more_security_logs',
                amount: spbcSettingsSecLogs.amount * (+spbcSettingsSecLogs.clicks+1),
            };
            let params = {
                button: this,
                spinner: this.nextElementSibling,
                wrapper: jQuery('#spbc_tbl__secuirty_logs').find('tbody'),
                callback: spbcSecLogsShowMoreCallback,
            };
            spbcSendAJAXRequest( data, params );
        } else {
            // Hide "More logs" button, show "Control Panel" button
            jQuery(this).hide();
            jQuery(this).siblings('.spbc__show_more_logs').css('display', 'inline-block');
        }
    });

    if (jQuery('#spbc_tbl__secuirty_logs tbody tr').length < 20) {
        jQuery('#spbc_show_more_button').click();
    }
}

/**
 * Callback for SHOW MORE SECURITY LOGS
 * @param {*} result
 * @param {*} data
 * @param {*} params
 */
function spbcSecLogsShowMoreCallback(result, data, params) {
    if (result.size > 0) {
        jQuery(params.wrapper).html(result.html);
        spbcTblRowActionsListen();
        spbcStartShowHide();

        if (jQuery('#spbc_tbl__secuirty_logs tbody tr').length < 20) {
            jQuery('#spbc_show_more_button').click();
        }
    } else {
        // Hide "More logs" button, show "Control Panel" button
        jQuery(params.button).hide();
        jQuery(params.button).siblings('.spbc__show_more_logs').css('display', 'inline-block');
    }
}

/**
 * Allow IP
 * @param {*} ip
 * @return {boolean}
 */
function spbcSecLogsAllowIp(ip) { // eslint-disable-line no-unused-vars
    spbcSecLogsFilterIp( ip, 'allow');
    return false;
}

/**
 * Ban IP
 * @param {*} ip
 * @return {boolean}
 */
function spbcSecLogsBanIp(ip) { // eslint-disable-line no-unused-vars
    spbcSecLogsFilterIp( ip, 'deny');
    return false;
}

/**
 * Filter IP
 * @param {*} ip
 * @param {*} status
 * @param {*} bulk
 * @return {boolean}
 */
function spbcSecLogsFilterIp( ip, status, bulk = false) {
    const data = {
        action: 'spbc_tc__filter_ip',
        ip: ip,
        status: status,
    };
    const params = {
        status: status,
    };
    if (!bulk) {
        params.callback = spbcSecLogsAllowIpCallback;
    }
    spbcSendAJAXRequest( data, params );

    return false;
}

/**
 * Callback for FILTER IP
 * @param {*} result
 * @param {*} data
 */
function spbcSecLogsAllowIpCallback(result, data) {
    console.log(data);
    if (result.success) {
        let msg = data.status === 'allow' ? 'Allowed' : 'Banned';
        alert('Success. Selected IPs have been ' + msg + '. Changes will be applied within 10 minutes.');
    } else {
        alert(result.data);
    }
}

jQuery(document).ready(function() {
    spbcTblRowActionsListen(); // Table. Row actions handler
    spbcTblBulkActionsListen();
    spbcTblPaginationListen(); // Table. Pagination handler
    spbcTblSortListen(); // Table. Sort handler

    // Handler for show more SECURITY LOGS
    spbcSecLogsShowMoreListen();

    // Start to hide long values in a table
    spbcStartShowHide();
});
